/* Zona Verde – interacciones propias de cada vista. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;
  var onFrame = [];
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      onFrame.forEach(function (fn) { fn(); });
      ticking = false;
    });
  }, { passive: true });

  /* Parallax suave: data-parallax="0.08" */
  if (!reduce) {
    var capas = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (capas.length) {
      onFrame.push(function () {
        var vh = window.innerHeight;
        capas.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var centro = r.top + r.height / 2 - vh / 2;
          el.style.translate = '0 ' + (centro * -parseFloat(el.dataset.parallax)).toFixed(1) + 'px';
        });
      });
    }
  }

  /* Manifiesto: las palabras se colorean al avanzar el scroll */
  document.querySelectorAll('[data-palabras]').forEach(function (p) {
    var palabras = p.textContent.trim().split(/\s+/);
    p.innerHTML = palabras.map(function (w) { return '<span class="palabra">' + w + '</span>'; }).join(' ');
    var spans = p.querySelectorAll('.palabra');
    if (reduce) { spans.forEach(function (s) { s.classList.add('is-on'); }); return; }
    var pintar = function () {
      var r = p.getBoundingClientRect();
      var vh = window.innerHeight;
      var avance = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var n = Math.round(avance * spans.length);
      spans.forEach(function (s, i) { s.classList.toggle('is-on', i < n); });
    };
    onFrame.push(pintar);
    pintar();
  });

  /* Contadores animados: data-contar="60" o cifras de .stat__num */
  var contadores = document.querySelectorAll('[data-contar], .stat__num');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var original = el.textContent.trim();
        var m = original.match(/^(\D*)(\d+)(.*)$/);
        if (!m) return;
        var fin = parseInt(m[2], 10), t0 = null, dur = 1200;
        var paso = function (t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var ease = 1 - Math.pow(1 - k, 3);
          el.textContent = m[1] + Math.round(fin * ease) + m[3];
          if (k < 1) requestAnimationFrame(paso); else el.textContent = original;
        };
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.6 });
    contadores.forEach(function (c) { io.observe(c); });
  }

  /* Ficha de producto: barra de compra fija */
  var barra = document.querySelector('[data-barra-compra]');
  var buy = document.querySelector('[data-buy]');
  var form = document.getElementById('ProductForm');
  if (barra && buy && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      barra.classList.toggle('is-visible', visible);
      barra.setAttribute('aria-hidden', String(!visible));
      barra.querySelector('[data-barra-add]').tabIndex = visible ? 0 : -1;
    }).observe(buy);
    barra.querySelector('[data-barra-add]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
    });
    var json = document.querySelector('[data-product-json]');
    var producto = json ? JSON.parse(json.textContent) : null;
    var precioBarra = barra.querySelector('[data-barra-precio]');
    form.addEventListener('change', function () {
      if (!producto || !precioBarra) return;
      var id = form.querySelector('[data-variant-id]').value;
      var v = producto.variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      var fmt = new Intl.NumberFormat('es-PE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PEN' });
      precioBarra.textContent = fmt.format(v.price / 100) + ' · ' + v.title;
    });
  }

  /* Calculadora de bocaditos */
  document.querySelectorAll('[data-calc]').forEach(function (calc) {
    var rango = calc.querySelector('[data-calc-invitados]');
    var out = calc.querySelector('[data-calc-invitados-out]');
    var wa = calc.querySelector('[data-calc-wa]');
    var porc = parseInt(calc.dataset.porc || '65', 10) / 100;
    var pS = parseFloat(calc.dataset.precioSalado || '2');
    var pD = parseFloat(calc.dataset.precioDulce || '1.7');
    var fmt = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', maximumFractionDigits: 0 });
    var redondear = function (n) { return Math.max(50, Math.ceil(n / 50) * 50); };
    var animar = function (el, valor) {
      var desde = parseInt(el.textContent.replace(/\D/g, ''), 10) || 0, t0 = null;
      var paso = function (t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 450);
        el.textContent = Math.round(desde + (valor - desde) * k);
        if (k < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };
    var actualizar = function () {
      var inv = parseInt(rango.value, 10);
      var tipo = calc.querySelector('input[name="calc-tipo"]:checked');
      var porPersona = tipo ? parseInt(tipo.value, 10) : 10;
      var salados = redondear(inv * porPersona * porc);
      var dulces = redondear(inv * porPersona * (1 - porc));
      out.textContent = inv;
      animar(calc.querySelector('[data-calc-total]'), salados + dulces);
      animar(calc.querySelector('[data-calc-salados]'), salados);
      animar(calc.querySelector('[data-calc-dulces]'), dulces);
      calc.querySelector('[data-calc-presupuesto]').textContent = fmt.format(salados * pS + dulces * pD);
      var msg = 'Hola Zona Verde, quiero cotizar un evento: ' + (tipo ? tipo.dataset.nombre : 'evento') +
        ' para ' + inv + ' invitados (aprox. ' + salados + ' salados y ' + dulces + ' dulces).';
      wa.href = 'https://wa.me/' + calc.dataset.wa + '?text=' + encodeURIComponent(msg);
    };
    calc.addEventListener('input', actualizar);
    calc.addEventListener('change', actualizar);
    actualizar();
  });
})();
